import React from 'react'
import { lifecycle, compose, branch, renderNothing, renderComponent, withProps } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions } from '../../modules/dealers'
import TryAgain from '../../components/TryAgain'
import Loading from '../../components/Loading'

const failed = ({ failFetchDealer, fetchingDealer, successFetchDealer, currentDealer }) =>
  failFetchDealer && !fetchingDealer && !successFetchDealer && !currentDealer
const isFetching = ({ failFetchDealer, fetchingDealer, successFetchDealer, currentDealer }) =>
  !failFetchDealer && fetchingDealer && !successFetchDealer && !currentDealer
const isInitial = ({ failFetchDealer, fetchingDealer, successFetchDealer, currentDealer }) =>
  !failFetchDealer && !fetchingDealer && !successFetchDealer && !currentDealer

const fetchDealerCallback = ({ match: { params: { dealer_id } }, fetchDealer, role, user, currentDealer }) => () => {
  user && role === 'staff' && dealer_id && currentDealer && currentDealer.id !== dealer_id && fetchDealer(dealer_id)
}

const TryAgainDealer = ({ failFetchDealer, ...props }) =>
  <TryAgain label={failFetchDealer} onTryAgain={fetchDealerCallback(props)} />

const nonOptimalStates = (states) =>
  compose(...states.map(state =>
    branch(state.when, state.render)))

const withLifeCycle = lifecycle({
  componentDidMount() {
    fetchDealerCallback(this.props)()
  },
  componentWillUnmount() {
    this.props.resetState()
  }
})

const mapStateToProps = state => ({
  ...state.dealers || {},
  role: state.settings.role,
  user: state.auth.user
})
const mapDispatchToProps = dispatch => ({ ...bindActionCreators(actions, dispatch), dispatch })

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withLifeCycle,
  nonOptimalStates([
    { when: isFetching, render: renderComponent(withProps({ label: 'Loading Dealer' })(Loading)) },
    { when: failed, render: renderComponent(TryAgainDealer) },
    { when: isInitial, render: renderNothing }
  ])
)
